import React, { PropsWithChildren, useContext, useMemo, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { EnrichedMarkdownText } from 'react-native-enriched-markdown';
import { Linking } from 'react-native';

const styles = StyleSheet.create({
});

interface DisplayMarkdownProps {
  markdown: string,
};

export function DisplayMarkdown({
  markdown,
}: DisplayMarkdownProps) : React.ReactNode {
  // https://github.com/software-mansion/enriched-markdown/blob/main/docs/STYLES.md
  const markdownStyles = useMemo(() => ({
    paragraph: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h1: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h2: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h3: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h4: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h5: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    h6: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    list: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    codeBlock: {
      color: AppConsts.DEFAULT_FONT_COLOR,
    },
    blockquote: {
      color: AppConsts.DEFAULT_FONT_COLOR,
      borderColor: AppConsts.COLOR2,
      borderWidth: 3,
      backgroundColor: 'transparent',
      padding: 5,
      marginBottom: 5,
    }
  }), []);

  // https://github.com/software-mansion/enriched-markdown/blob/main/docs/TEXT.md
  // https://github.com/software-mansion/enriched-markdown/blob/main/docs/API_REFERENCE.md
  // https://github.com/software-mansion/enriched-markdown/blob/main/docs/STYLES.md

  return (
    <EnrichedMarkdownText
      markdown={markdown}
      onLinkPress={({ url }) => Linking.openURL(url)}
      selectable={true}
      flavor="github"
      selectionColor={"#71719c"}
      markdownStyle={markdownStyles}
    />
  );
};
